// Mock data for Knowledge Graph Analysis
// This file contains sample data for demonstration and testing purposes

export const knowledgeGraphMockData = {
  // Mock samples for dropdown selection
  sampleList: [
    { id: 'moonAndRabbit', name: '月亮與兔子' },
    { id: 'chinesePoetry', name: '春曉' },
    { id: 'chineseEssay', name: '我的理想' },
    { id: 'loveStory', name: '海邊的告白（愛情）' },
    { id: 'detectiveMystery', name: '失落的藍寶石（推理）' },
    { id: 'narrativeJourney', name: '遠方的列車（記敘）' },
    { id: 'schoolLife', name: '操場的風（校園）' },
    { id: 'historicalTale', name: '城牆上的火光（歷史）' },
    { id: 'sciFiExploration', name: '銀河邊緣（科幻）' },
    { id: 'fantasyLegend', name: '山海秘錄（奇幻）' },
    { id: 'familyDrama', name: '回家的路（親情）' }
  ],

  // Sample text for analysis
  sampleTexts: {
    moonAndRabbit: `《月亮與兔子》 (The Moon and the Rabbit)
這是一個關於月亮和一隻兔子，關於承諾和犧牲的故事。 很久很久以前，在一個遙遠的星球上，住著一隻純潔的白兔。他和其他兔子一樣，每天都在田野裡奔跑，享受著陽光和自由。然而，他卻有著一顆不同尋常的心，他對月亮充滿了好奇和敬畏。
每天晚上，他都會抬頭仰望著那皎潔的月亮，心中充滿了對月亮的嚮往。他想知道月亮上到底有什麼，他多麼渴望能和月亮親近。有一天，他終於下定決心，要爬上月亮。
他開始了他的攀登之旅。他跳過高山，越過河流，穿過森林，一路向著月亮的方向前進。他的腿跑得酸痛，他的身體疲憊不堪，但他從未放棄。他知道，只有到達月亮，他才能找到他想要的答案。
經過漫長的跋涉，他終於來到了月亮下。他用盡最後的力氣，奮力一躍，跳上了月亮。
月亮上，他看到了與地球截然不同的景象。這裡沒有綠色的田野，沒有奔跑的兔子，只有一片荒涼的土地和無盡的黑暗。他失望了，但他沒有退縮，他決定要好好探索這個地方。 
他漫無目的地走著，尋找著任何生命存在的跡象。突然，他看到了一位老爺爺，他坐在一個小小的茅草屋裡，面容慈祥，眼神中充滿了智慧。
白兔好奇地走上前，問道：「老爺爺，您好。請問您知道這裡是什麼地方嗎？」 
老爺爺抬起頭，微笑著說道：「孩子，你終於來了。這裡就是月亮，是我和我的妻子居住的地方。」 
白兔驚訝地問道：「您和您的妻子？可是，這裡除了您，我沒有看到任何其他人。」
老爺爺嘆了口氣，說道：「孩子，我的妻子已經逝去了。她為了讓我能繼續留在月亮上，犧牲了自己的生命。」
白兔更加不解了，問道：「為什麼要犧牲生命呢？難道不能一起生活嗎？」 
老爺爺緩緩地解釋道：「孩子，這個星球上的生命，都以月亮的光芒為生。而我，卻因為年邁體衰，無法再發出光芒。我的妻子為了讓我繼續留在這裡，她用自己的生命，將我的靈魂與月亮融合，讓我化為月亮的一部分，繼續照耀著這個星球。」
白兔聽了，內心受到了極大的震撼。他無法想像，為了另一個人，可以付出如此巨大的犧牲。 
他問道：「那麼，您為什麼不回到地球上呢？那裡還有很多您的親人，還有很多美好的事物。」
老爺爺搖了搖頭，說道：「孩子，我已經回不去了。我的靈魂已經與月亮融為一體，我必須在這裡，繼續履行我的職責，照耀著這個星球。」
白兔看著老爺爺堅定的眼神，明白了，他明白了犧牲的意義，也明白了承諾的重量。
他向老爺爺承諾，他會將這個故事，永遠地流傳下去。 
白兔告別了老爺爺，回到了地球。他把在月亮上所見所聞，告訴了所有的兔子。 他們聽了，都深深地被老爺爺和他的妻子的故事所感動。
從那天起，每一隻兔子，都會在月圓之夜，抬頭仰望著月亮，思念著老爺爺和他的妻子。 他們也學會了，在生活中，要珍惜身邊的人，也要勇敢地承擔起自己的責任。
這個故事，也一代一代地流傳了下來，成為了中華民族的經典傳說。`,

    chinesePoetry: `《春曉》孟浩然
春眠不覺曉，處處聞啼鳥。
夜來風雨聲，花落知多少。

這首詩描繪了春天清晨的景象，詩人在春天的早晨醒來，聽到到處都是鳥兒的鳴叫聲。昨夜風雨交加，不知道有多少花朵被風雨打落。詩人通過聽覺感受春天的氣息，展現了對春天的喜愛和對美好事物的珍惜。`,

    chineseEssay: `《我的理想》
每個人都有自己的理想，我的理想是成為一名教師。教師是太陽底下最光輝的職業，他們用知識的甘露澆灌學生心田，用智慧的明燈照亮學生前進的道路。
我之所以選擇教師這個職業，是因為我深深體會到教育的重要性。在我成長的過程中，有許多老師給予了我無私的關愛和指導，他們不僅傳授我知識，更重要的是教會了我如何做人，如何面對生活中的困難和挑戰。
作為一名教師，我希望能夠像我的老師們一樣，用愛心和耐心去教育每一個學生。我相信，每個學生都有自己的潛能和特長，只要給予適當的引導和鼓勵，他們都能夠綻放出屬於自己的光彩。
我深知，要成為一名優秀的教師並不容易，需要不斷學習和提升自己。我會努力學習專業知識，提高教學技能，同時也要培養自己的品德修養，做學生的榜樣。
 我相信，通過自己的努力和堅持，我一定能夠實現自己的理想，成為一名受人尊敬的教師，為祖國的教育事業貢獻自己的力量。`,

    loveStory: `《海邊的告白》
夏末的夜潮一層一層撲上堤岸，退去時在礁石間留下細碎的白沫。阿岑與阿薇沿著石階往下走，腳步被海風推得有些踉蹌。從國小到高中，他們一起背著書包穿過同一條巷子，後來各自離開這座小漁村去尋自己的世界；再見面已是五年之後。這五年間，阿岑在城裡拜師學藝，從粗糙的木板磨出第一道光澤；阿薇留在家裡，接手父親的雜貨店，認識每一個來買鹽與火柴的顧客。村裡的老人說他們有緣，卻像兩條在不同潮汐裡游動的小魚，總是錯開。

這次他們約在海邊。阿岑提著一個小木盒，盒蓋上刻著不太熟練的藤蔓花紋，像是他急著把心意雕成可以握在掌心裡的形狀。阿薇問他盒子裡是什麼，他說等風小一點再打開——海面的浪像銀色的鱗片，月亮在雲後若隱若現。阿薇笑說，你還是像小時候那樣愛賣關子。兩人坐在濕涼的礁石上，談起這幾年的生活：城裡的房租怎麼像潮水一樣漲；雜貨店後面的芒草地又被颱風壓倒；誰家的小孩上學了，誰家的老人不在了。話題繞了一圈又一圈，始終沒有靠近心口最熱的那一點。

直到夜色更深，阿岑把木盒推到阿薇面前。盒子裡是一封摺得整整齊齊的信，紙張被拋光般地柔順，是他反覆握過的痕跡。信裡寫著他在外地的日子：被師傅斥責、被客戶嫌棄、第一次獨立完成櫥櫃時激動得不敢碰手上的漆。他在每個段落結尾都寫上「我想妳」。阿薇讀著讀著，指尖因海風微微發抖。她說她也曾想離開，卻因為父親生病而留下；她原以為自己會一直在這裡，看潮起潮落，看招牌被鹽霧腐蝕，再重新油上亮漆。她說到一半，忽然笑了，說也許留下不是妥協，而是慢慢把想做的事，擺在家門口。

阿岑沉默地看著她，海浪在他們腳邊把碎貝殼推來推去。他說，城裡的師傅願意讓他暫時回鄉，幫人修舊船、做桌椅；只要有人需要手藝，哪裡都有他的工作。他問阿薇：如果我們把店面後面的堆貨間打通，做一張大工作桌，讓顧客點茶的時候可以看到木屑慢慢落下，會不會有人喜歡？阿薇愣住了，眼睛被月光照得很亮。她說：那就試試吧。她說她可以把小店的帳目理清，把靠近窗子的那一櫃放上木作的小匙與托盤；她說颱風季過去之後，牆上剝落的那塊會重新粉刷，顏色要像日出時的淡粉。

浪頭忽然大起，濺濕了他們的鞋。阿岑拉起阿薇的手，兩人踉蹌著退到高處。阿薇握緊那個木盒，像握住一段未來。她說：我們可以慢慢來，先讓村裡的人喜歡，再讓外地的人願意來看海、喝茶、買一把妳做的匙、買一張你做的桌。阿岑說好。他們對著黑夜點頭，像是對著時間發了誓。海鳥貼著水面掠過，遠處的漁船開著黃燈，燈光在浪尖上碎成一串串的星。

回程的路上風越來越大，颱風在海面外繞行。阿薇忽然停下腳步，說她還想把店裡的老唱機修好，讓木屑的聲音與唱片的沙沙聲混在一起。阿岑說他會做一個可以關風的門楣，讓黃昏的光剛好落在工作桌的邊緣。兩人站在堤岸上看潮水吞下最後一塊礁石，誰也不再說話。他們知道，明天還要把冰箱的霜刮掉、把新進的茶葉分類、把舊帳整理出能夠看得懂的線。那是一條不會太快也不會太慢的路，而他們願意在上面一步一步走。`,

    detectiveMystery: `《失落的藍寶石》
古宅深處的鐘在午夜十二點敲了十三響，最後一響像是從牆裡滲出的嘆息。林琛踏進門時，長廊兩側的油畫都被白布覆住，只有最末端的壁爐裡還有火光，偶爾噼啪一聲。主人唐老爺雙手顫抖，他說鎖在保險櫃裡的藍寶石不見了，窗是關著的、門也沒有被撬開——一個標準的密室。當晚在場的人包括忠心耿耿的管家祁伯、沉默寡言的女僕娜塔、總在庭園流連的園丁阿洛，還有唐老爺唯一的外甥黎鵬。每個人都有不在場證明，也都各自握著不是秘密的秘密。

林琛先檢查保險櫃。指紋粉末呈現出幾乎整齊的塗抹痕跡，像是有人小心翼翼地擦去所有可能辨識的線條；但在黃銅轉盤的縫隙裡，他找到一點點亮晶晶的粉末，那不是金屬屑，而是細碎的玻璃渣。他讓眾人離開書房，自己在裡面走了一圈又一圈，從書桌到地毯，又從地毯到窗縫。他注意到壁爐旁的傘架裡，多了一把黑色長柄傘，傘面尚濕，像是剛從夜雨裡收回。

他一個一個詢問。管家祁伯說自己在地下酒窖盤點，女僕娜塔說她在溫室裡替蘭花換盆，園丁阿洛承認他溜到廚房偷喝了兩口白蘭地，外甥黎鵬則聲稱到鎮上寄信。賬都對不起來：溫室的門被內側反鎖；鎮上的郵局早在十點就關門；酒窖的鑰匙只有祁伯與唐老爺持有。林琛再次回到書房，他把壁爐裡的灰撥開，拾起一小段焦黑的信封角；他把黑傘拆開，發現傘柄中空、有可拆的螺牙；他把書桌抽屜裡的布面首飾盒對著燈一照，內層布上有極細的割裂紋路，像是被刀尖試過。

真相像潮水般回流：藍寶石其實在當晚就被換成玻璃仿品，真正的寶石被管家祁伯藏進雨傘柄。他這麼做不是為了偷，而是為了護。唐老爺在幾年前投資失敗，想把家族的傳承秘寶典當換錢；祁伯不忍，與多年照應的園丁合謀把寶石藏起來，打算等唐老爺冷靜再歸還。不料外甥黎鵬發現異樣，想先下手為強，便試圖燒掉自己寄出的勒索信以破壞證據。女僕娜塔知道了，便用她在溫室養成的耐心守在走廊口，確保沒人進出書房。每個人都以為自己守護了什麼，卻讓秘密越纏越深。

林琛把雨傘柄打開，藍寶石在火光裡流出一圈冷藍。他把傘交還唐老爺，說：「真正的密室不是書房，而是人心。你們各自鎖住了能說的話，也就鎖住了彼此。」唐老爺沉默很久，對祁伯深深一鞠躬。雨停了，鐘敲了一下，像是把夜晚收回抽屜。`,

    narrativeJourney: `《遠方的列車》
晨霧還沒散，阿禾就拖著箱子踏上月台。這是他離家工作的第三個年頭，回家的次數少得能用手指頭數出來。列車緩緩進站，車頭吐出白氣，像冬天的牲口在喘息。他把行李抬上行李架，懷裡還抱著一條自己織的圍巾——母親的手因為長年洗衣做飯生了凍瘡，冬天總是紅得發亮。對面的座位坐著談婚事的小情侶，路過的推車上綁著綠色帆布，賣咖啡的車伕喊一聲「熱的」。列車像一間長長的屋子，把陌生人的故事臨時擺在同一張桌上。

窗外的景色開始翻頁：城市的高樓退到遠處，倉庫、田地、堤防、烏鴉、路邊晾著的稻草人，像是有人用鉛筆在紙上畫了很久才敢著色。隔壁車廂傳來吉他聲，年輕人唱的是老歌；通道上有推著貨品的中年人，一面打電話一面皺眉；老奶奶拿出一盒針線，認真地補孫子的外套。阿禾突然想起自己剛到城裡的第一天，背上只有一個包，夜裡睡在出租屋的薄床墊上，隔壁屋裡還在吵架。他那時以為自己會待不下去，第二天卻去找工作，第三天就學會在工地上分辨不同木料的重量。

列車穿過隧道，黑暗把所有人的臉都揉成一塊，出隧道時陽光猛地撒進來，每個人都像被重新命名。阿禾把圍巾攤在膝上，忽然覺得這條路不只是從城到鄉的直線，而是一個巨大的圓。他繞了一圈，回來時也帶了新的東西：他學會在失敗裡找可以重來的方法；學會在工友難過時遞上一瓶溫的水；學會在夜裡對著窗外的黑暗說「我一定會回去」。

傍晚時分，列車駛上長橋。下方的河被夕陽燒得通紅，風從河面吹上來，吹過車窗縫，帶著濕潤的鹹味。阿禾把圍巾抱得更緊，像抱著從來不敢大聲說的想念。他突然明白，離開並不是背棄，而是為了讓自己有能力帶著故事與禮物回來。下一站就是故鄉，他看見遠處的山像一張熟悉的臉，正從暮色裡慢慢浮出來。`,

    schoolLife: `《操場的風》
畢業典禮前一週，校園裡的大榕樹落了一地黃花。風把花吹成一條條細細長長的路，通往操場、禮堂、教室與那條永遠走不完的走廊。籃球隊與合唱團被安排共用操場做最後一次彩排：籃球隊要演示一段象徵青春的快攻，合唱團要完成一首四部合唱的謝師曲。兩個社團都想把最好的一面留在學校的記憶裡，於是矛盾像積雲一樣暗暗升起。

衝突在午後爆發。籃球隊長阿杰要求延長十五分鐘練習，合唱團指揮小庭堅持按表排程。兩邊的人都紅了眼眶，誰也不肯退讓。導師把哨子拿在手裡卻沒有吹，他讓所有人坐下來聽操場上的風聲——風從看台縫裡鑽出來，吹過球框的鐵圈，穿過麥克風架子，再從旗杆上滑下來。風聽起來像一首沒有歌詞的歌。小庭忽然說：「我可以移一段，讓你們先走位。」阿杰也說：「我們把最後十五分鐘讓出來，借你們唱一次全曲。」

彩排重新開始。籃球隊在跑位時將球從合唱團前方傳過去，合唱團的人學著把聲音像球一樣輕輕接住、再傳回去。謝師曲唱到最後一段時，夕陽正好落在看台邊，所有人的影子拉得很長。阿杰忽然把球拋向天空，小庭的指揮棒也同時劃出最後一個圓。那一刻，操場像一張巨大的照片，把所有人的笑容固定在微風裡。`,

    historicalTale: `《城牆上的火光》
小城在戰事的邊緣顫抖，黃昏把城牆染成銅色。少年在哨塔上輪值點燈，手裡的火把是從前一班守衛那裡接來的，像一段還在燃燒的話。他沿著塔梯往上走，風從箭孔裡直直灌進來，把火焰吹得一高一低。他不敢讓火熄滅，因為這火是城內百姓晚間回家的指引，也是城外友軍辨認的標記。

塔樓裡有一張長桌，桌邊坐著一位女書吏，正在抄寫軍令。她抬頭看少年，說：「名字？」少年代號短短兩個字，像被戰爭磨得剩下骨頭。她把名字寫進名冊，又把一盞油燈推到他手邊。她說：「風大，燈要護好。」少年點點頭。他們並肩在塔上守著夜，偶爾聽見遠處的號角聲與鎧甲碰撞。女書吏說她從未上過戰場，但她知道，每一道被抄寫清楚的命令，都是盡量讓更多的人活著回家。

午夜時，城外忽然亮起火光，敵軍的斥候試圖靠近。少年把火把高高舉起，朝城內的烽燧台揮動三次；火光像一個字，迅速在城牆上奔跑。城內的鐘聲被敲醒，士兵們上城、弓弩上弦。女書吏握緊筆桿，手背發白。她在燈下寫下新的調度指示，少年把紙條綁在信鴿腳上。等危機過去，黎明漸亮，城裡傳來賣早餐的叫賣聲。少年把快要燒盡的火把插在牆縫裡，長長吐出一口氣。女書吏把名冊合上，說：「謝謝你的火。」少年笑了一下，說：「也謝謝妳的字。」`,

    sciFiExploration: `《銀河邊緣》
探索船「晨星號」在銀河邊陲漂行了三年，船體外殼被太陽風打出一道道細痕，像鯨魚身上的白紋。第七十九次躍遷後，他們抵達一片陌生星系：兩顆小行星以古怪的角度互繞，彷彿在無聲跳舞；一顆藍白色的冰原行星在遠處緩慢自轉，反射的光像極地的晨曦。船長下令釋放測試艙，隊伍帶著鑽冰設備降落。

冰層在鑽頭下發出低沉的嗡鳴，像厚玻璃在呻吟。第二日，他們在地底下找到一個古老訊標，外殼早已脆化，內部卻仍保存著微弱的能量。工程師破解語音後，船艙裡響起一段斷斷續續的呼喚：「別再尋找中心……中心會移動……我們的家被自己定義……」聲音忽遠忽近，像從千萬年前穿越冰層而來。船員們面面相覷，誰也說不出話。導航員在星圖上標註訊標位置，忽然發現這片星域不像他們以為的那樣在外圍——坐標會隨著測量者的參考點而變，所謂中心，只是參照選擇的結果。

回程前，船長讓每個人站在觀景窗前望一次故鄉行星。那顆藍綠色的小點在無邊黑暗中微微發光，像是一粒被宇宙呵護的種子。有人哭了，有人笑了，有人把手貼在玻璃上默念家人的名字。船醫說：「我們一直以為要找到宇宙的中心，其實是在學會如何把彼此放在心的中心。」所有人都點頭。晨星號點亮推進器，像一隻重新找到方向的鯨。

他們帶著訊標的備份離開，決定回到母港與其他艦隊分享這段訊息。船上紀錄員在航海日誌結尾寫著：「家的定義不在座標，而在同行的人。」當日誌被封存，艙門外的星光一閃一閃，像是在為他們的理解鼓掌。`,

    fantasyLegend: `《山海秘錄》
山脈像一條沉睡的龍，鱗片是層層疊疊的雲。初霜之夜，雲骨橋會在兩座雪峰之間現形，橋面被霜覆著薄薄一層銀光。少年背著祖傳的銅鈴來到谷口，鈴身有細小的刻紋，記錄著家族與守護獸的約定。據說只要在橋上敲響鈴聲，失散的守護獸便能聽見，循聲而來。然而鈴聲若被雜念污染，來的就不是夥伴，而是迷途的影。

少年踏上橋，第一聲鈴響清澈，像溪水碰到石頭。風把聲音送往雪松之巔，又從雪松針葉間彈回。他走得越高，腳下的雲就越薄，能看見遠處山谷裡村莊的燈。第二聲鈴響帶著一點顫抖，他想起多年以前守護獸離去的夜晚，那時他還小，不懂承諾的重量。第三聲鈴響之前，他停下來調整呼吸，把關於恐懼與後悔的念頭一一放下。

當第三聲鈴響穿過夜空，雪松之巔亮起一點淡金色的光。一頭通體雪白、眼如琥珀的獸從霜霧中走出，步伐輕得像不沾地。牠在橋頭停下，望向少年。少年把鈴舉到胸前，低聲唸出家族的古老誓詞：「願以心為橋，以信為路。」守護獸緩緩靠近，額頭碰了碰鈴身，發出一聲清脆的回響。那聲音像把長久的離散收成一句「我回來了」。`,

    familyDrama: `《回家的路》
父親住院的那一週，屋裡的燈總是比以往亮得更晚。姊姊白天守在病房，弟弟夜裡接手。兩人像接力一樣把時間交給彼此，誰也不敢鬆手。病房窗外的楓樹每天落一地紅葉，掃完又落；走廊盡頭的飲水機不停滾著，像提醒每個人別忘記喝水。醫師說父親需要做一個小手術，風險不大，但要耐心復健。姊弟倆第一次發現，原來照顧一個人不只是端湯遞藥，還包括把彼此心裡想說的話說出來。

父親以往嚴厲，話總是短。住院後他沉默了許多，偶爾會盯著窗外出神。姊姊問他在想什麼，他說想起年輕時背著工具箱走遍幾個工地，冬天手指凍得發木，還是要把釘子一顆一顆敲進木條。弟弟在一旁聽著，忽然明白父親的不善言辭，並不是沒有愛，而是把愛都放在做好的桌椅、修好的門鎖裡。手術那天，姊弟倆在走廊上來回踱步，鞋底與地板摩擦出細碎的聲音。手術室的燈亮著，他們彼此不說話，只是抓著同一杯溫的豆漿。

出院當晚，父親坐在陽台上看月亮。秋夜的風不冷不熱，剛好能讓人把話說完整。他說如今走路慢了，才知道原來家不是一個點，而是彼此相望的方向：有人在那裡等你，有人願意把路燈留到最後一盞。姊姊把毯子蓋到父親膝上，弟弟把水壺放在手邊。他們一起聽街角小販收攤的聲音，聽貓跳過圍牆的聲音，聽彼此的呼吸一上一下。那一晚，屋裡的燈並沒有很晚才滅，因為每個人心裡都亮著。`
  },

  // Pre-analyzed knowledge graph data
  analyzedGraphs: {
    moonAndRabbit: {
      nodes: [
        {
          id: 'white_rabbit',
          name: '白兔',
          type: 'protagonist',
          category: 'character',
          description: '純潔的白兔，對月亮充滿好奇和敬畏',
          importance: 10,
          x: 100,
          y: 50,
          z: 0,
          radius: 20
        },
        {
          id: 'old_man',
          name: '老爺爺',
          type: 'helper',
          category: 'character',
          description: '居住在月亮上的智慧老人，原為星球守護者',
          importance: 9,
          x: -80,
          y: 120,
          z: 20,
          radius: 18
        },
        {
          id: 'wife',
          name: '老爺爺的妻子',
          type: 'sacrificial',
          category: 'character',
          description: '為了愛而犧牲的女性，將靈魂獻給月亮',
          importance: 8,
          x: -60,
          y: -100,
          z: 30,
          radius: 16
        },
        {
          id: 'other_rabbits',
          name: '其他兔子',
          type: 'community',
          category: 'character',
          description: '地球上的兔子群體，故事的傳承者',
          importance: 5,
          x: 200,
          y: 80,
          z: -10,
          radius: 10
        },
        {
          id: 'moon',
          name: '月亮',
          type: 'destination',
          category: 'place',
          description: '神秘的目的地，老爺爺的住所，星球的光源',
          importance: 10,
          x: 0,
          y: -100,
          z: 50,
          radius: 20
        },
        {
          id: 'earth',
          name: '地球',
          type: 'origin',
          category: 'place',
          description: '兔子們生活的家園，生命的起源地',
          importance: 8,
          x: 150,
          y: -50,
          z: -30,
          radius: 16
        },
        {
          id: 'fields',
          name: '田野',
          type: 'habitat',
          category: 'place',
          description: '兔子們奔跑的綠色田野，自由的家園',
          importance: 6,
          x: 120,
          y: 100,
          z: -20,
          radius: 12
        },
        {
          id: 'mountains',
          name: '高山',
          type: 'obstacle',
          category: 'place',
          description: '白兔攀登途中的障礙，考驗意志',
          importance: 4,
          x: 80,
          y: -120,
          z: 10,
          radius: 8
        },
        {
          id: 'rivers',
          name: '河流',
          type: 'obstacle',
          category: 'place',
          description: '白兔越過的水域，旅程的挑戰',
          importance: 4,
          x: -100,
          y: 60,
          z: 5,
          radius: 8
        },
        {
          id: 'forest',
          name: '森林',
          type: 'obstacle',
          category: 'place',
          description: '白兔穿過的茂密森林，未知的探索',
          importance: 4,
          x: -120,
          y: -40,
          z: 15,
          radius: 8
        },
        {
          id: 'hut',
          name: '茅草屋',
          type: 'dwelling',
          category: 'place',
          description: '老爺爺在月亮上的小屋，智慧的居所',
          importance: 5,
          x: -40,
          y: 140,
          z: 25,
          radius: 10
        },
        {
          id: 'planet',
          name: '遙遠的星球',
          type: 'setting',
          category: 'place',
          description: '故事發生的星球，生命的搖籃',
          importance: 7,
          x: 180,
          y: -80,
          z: -40,
          radius: 14
        },
        {
          id: 'moonlight',
          name: '月光',
          type: 'life_force',
          category: 'object',
          description: '星球生命的光芒來源，生命的能量',
          importance: 9,
          x: -120,
          y: -80,
          z: 40,
          radius: 18
        },
        {
          id: 'soul',
          name: '靈魂',
          type: 'essence',
          category: 'object',
          description: '與月亮融合的老爺爺靈魂，永恆的存在',
          importance: 8,
          x: -80,
          y: -60,
          z: 35,
          radius: 16
        },
        {
          id: 'story',
          name: '故事',
          type: 'legacy',
          category: 'object',
          description: '代代相傳的經典傳說，文化的傳承',
          importance: 7,
          x: 160,
          y: 120,
          z: -15,
          radius: 14
        },
        {
          id: 'promise',
          name: '承諾',
          type: 'bond',
          category: 'object',
          description: '白兔對老爺爺的承諾，責任的體現',
          importance: 6,
          x: 140,
          y: -20,
          z: 5,
          radius: 12
        },
        {
          id: 'sacrifice',
          name: '犧牲',
          type: 'theme',
          category: 'object',
          description: '愛與奉獻的核心主題，人性的光輝',
          importance: 8,
          x: 80,
          y: 150,
          z: -20,
          radius: 16
        }
      ],
      links: [
        {
          from: 'white_rabbit',
          to: 'moon',
          type: '嚮往',
          strength: 10,
          source: 'white_rabbit',
          target: 'moon',
          width: 5
        },
        {
          from: 'white_rabbit',
          to: 'old_man',
          type: '遇見',
          strength: 9,
          source: 'white_rabbit',
          target: 'old_man',
          width: 4.5
        },
        {
          from: 'old_man',
          to: 'wife',
          type: '愛護',
          strength: 10,
          source: 'old_man',
          target: 'wife',
          width: 5
        },
        {
          from: 'wife',
          to: 'old_man',
          type: '犧牲',
          strength: 10,
          source: 'wife',
          target: 'old_man',
          width: 5
        },
        {
          from: 'old_man',
          to: 'moon',
          type: '融合',
          strength: 9,
          source: 'old_man',
          target: 'moon',
          width: 4.5
        },
        {
          from: 'white_rabbit',
          to: 'other_rabbits',
          type: '分享故事',
          strength: 7,
          source: 'white_rabbit',
          target: 'other_rabbits',
          width: 3.5
        },
        {
          from: 'white_rabbit',
          to: 'mountains',
          type: '跳過',
          strength: 6,
          source: 'white_rabbit',
          target: 'mountains',
          width: 3
        },
        {
          from: 'white_rabbit',
          to: 'rivers',
          type: '越過',
          strength: 6,
          source: 'white_rabbit',
          target: 'rivers',
          width: 3
        },
        {
          from: 'white_rabbit',
          to: 'forest',
          type: '穿過',
          strength: 6,
          source: 'white_rabbit',
          target: 'forest',
          width: 3
        },
        {
          from: 'old_man',
          to: 'hut',
          type: '居住',
          strength: 7,
          source: 'old_man',
          target: 'hut',
          width: 3.5
        },
        {
          from: 'moonlight',
          to: 'planet',
          type: '照耀',
          strength: 9,
          source: 'moonlight',
          target: 'planet',
          width: 4.5
        },
        {
          from: 'white_rabbit',
          to: 'promise',
          type: '許下',
          strength: 8,
          source: 'white_rabbit',
          target: 'promise',
          width: 4
        },
        {
          from: 'story',
          to: 'other_rabbits',
          type: '傳承',
          strength: 8,
          source: 'story',
          target: 'other_rabbits',
          width: 4
        },
        {
          from: 'other_rabbits',
          to: 'fields',
          type: '奔跑',
          strength: 6,
          source: 'other_rabbits',
          target: 'fields',
          width: 3
        },
        {
          from: 'soul',
          to: 'moon',
          type: '融為一體',
          strength: 9,
          source: 'soul',
          target: 'moon',
          width: 4.5
        }
      ],
      summary: {
        totalEntities: 16,
        totalRelationships: 15,
        mainThemes: ['犧牲', '愛', '承諾', '探索', '傳承'],
        keyInsights: '故事探討了犧牲與愛的深刻主題，通過白兔的旅程展現了對未知的探索精神，以及承諾和傳承的重要性。'
      }
    },

    chinesePoetry: {
      nodes: [
        {
          id: 'poet',
          name: '孟浩然',
          type: 'protagonist',
          category: 'character',
          description: '唐代詩人，詩歌的作者',
          importance: 8,
          x: 0,
          y: 0,
          z: 0,
          radius: 16
        },
        {
          id: 'spring_morning',
          name: '春曉',
          type: 'theme',
          category: 'object',
          description: '春天清晨的景象，詩歌的主題',
          importance: 10,
          x: 100,
          y: 50,
          z: 20,
          radius: 20
        },
        {
          id: 'birds',
          name: '鳥兒',
          type: 'life_force',
          category: 'object',
          description: '到處鳴叫的鳥兒，春天的象徵',
          importance: 7,
          x: -80,
          y: 120,
          z: 10,
          radius: 14
        },
        {
          id: 'wind_rain',
          name: '風雨',
          type: 'obstacle',
          category: 'object',
          description: '昨夜風雨交加，自然的變化',
          importance: 6,
          x: 120,
          y: -80,
          z: -10,
          radius: 12
        },
        {
          id: 'flowers',
          name: '花朵',
          type: 'life_force',
          category: 'object',
          description: '被風雨打落的花朵，生命的脆弱',
          importance: 7,
          x: -60,
          y: -100,
          z: 15,
          radius: 14
        },
        {
          id: 'hearing',
          name: '聽覺感受',
          type: 'essence',
          category: 'object',
          description: '通過聽覺感受春天的氣息',
          importance: 8,
          x: 80,
          y: 150,
          z: -20,
          radius: 16
        }
      ],
      links: [
        {
          from: 'poet',
          to: 'spring_morning',
          type: '描繪',
          strength: 9,
          source: 'poet',
          target: 'spring_morning',
          width: 4.5
        },
        {
          from: 'spring_morning',
          to: 'birds',
          type: '包含',
          strength: 8,
          source: 'spring_morning',
          target: 'birds',
          width: 4
        },
        {
          from: 'spring_morning',
          to: 'wind_rain',
          type: '經歷',
          strength: 7,
          source: 'spring_morning',
          target: 'wind_rain',
          width: 3.5
        },
        {
          from: 'wind_rain',
          to: 'flowers',
          type: '打落',
          strength: 8,
          source: 'wind_rain',
          target: 'flowers',
          width: 4
        },
        {
          from: 'poet',
          to: 'hearing',
          type: '運用',
          strength: 9,
          source: 'poet',
          target: 'hearing',
          width: 4.5
        },
        {
          from: 'hearing',
          to: 'birds',
          type: '感受',
          strength: 8,
          source: 'hearing',
          target: 'birds',
          width: 4
        }
      ],
      summary: {
        totalEntities: 6,
        totalRelationships: 6,
        mainThemes: ['春天', '自然', '聽覺', '生命'],
        keyInsights: '詩人通過聽覺感受春天的氣息，展現了對春天的喜愛和對美好事物的珍惜，體現了對自然和生命的關懷。'
      }
    },

    loveStory: {
      nodes: [
        { id: 'acen', name: '阿岑', type: 'protagonist', category: 'character', description: '木工學徒，故事主角', importance: 9, x: -60, y: 0, z: 0, radius: 16 },
        { id: 'awi', name: '阿薇', type: 'helper', category: 'character', description: '經營小店的女孩', importance: 9, x: 60, y: 0, z: 0, radius: 16 },
        { id: 'seaside', name: '海邊', type: 'setting', category: 'place', description: '兩人告白之地', importance: 8, x: 0, y: -100, z: 10, radius: 14 },
        { id: 'seabreeze', name: '海風', type: 'life_force', category: 'object', description: '清新的生命氣息', importance: 6, x: -110, y: -40, z: 0, radius: 10 },
        { id: 'letter_love', name: '書信', type: 'legacy', category: 'object', description: '未說完的話', importance: 7, x: -110, y: 60, z: 0, radius: 12 },
        { id: 'woodbox', name: '木盒', type: 'legacy', category: 'object', description: '阿岑親手打造的盒子', importance: 6, x: 110, y: 60, z: 0, radius: 10 },
        { id: 'promiseLove', name: '約定', type: 'bond', category: 'object', description: '一起開店的計畫', importance: 8, x: 0, y: 100, z: 0, radius: 12 },
        { id: 'loveTheme', name: '愛與成長', type: 'theme', category: 'object', description: '核心主題', importance: 8, x: 90, y: -60, z: 0, radius: 12 }
      ],
      links: [
        { from: 'acen', to: 'awi', type: '告白', strength: 9, source: 'acen', target: 'awi', width: 4 },
        { from: 'acen', to: 'letter_love', type: '交付', strength: 7, source: 'acen', target: 'letter_love', width: 3.5 },
        { from: 'awi', to: 'promiseLove', type: '回應', strength: 8, source: 'awi', target: 'promiseLove', width: 4 },
        { from: 'seaside', to: 'promiseLove', type: '見證', strength: 7, source: 'seaside', target: 'promiseLove', width: 3.5 },
        { from: 'seabreeze', to: 'loveTheme', type: '襯托', strength: 6, source: 'seabreeze', target: 'loveTheme', width: 3 }
      ],
      summary: { totalEntities: 8, totalRelationships: 5, mainThemes: ['成長','承諾','勇氣'], keyInsights: '海邊的相遇將情感化為共同的未來計畫。' }
    },

    detectiveMystery: {
      nodes: [
        { id: 'detective', name: '林琛', type: 'protagonist', category: 'character', description: '受邀調查的偵探', importance: 9, x: -10, y: 0, z: 0, radius: 16 },
        { id: 'butler', name: '管家', type: 'helper', category: 'character', description: '家族守護者', importance: 8, x: -90, y: -30, z: 0, radius: 14 },
        { id: 'niece', name: '外甥', type: 'community', category: 'character', description: '年輕家人', importance: 6, x: 90, y: -30, z: 0, radius: 12 },
        { id: 'mansion', name: '古宅', type: 'setting', category: 'place', description: '案發地點', importance: 8, x: 0, y: -110, z: 10, radius: 14 },
        { id: 'sapphire', name: '藍寶石', type: 'legacy', category: 'object', description: '失竊之物', importance: 10, x: -60, y: 80, z: 0, radius: 16 },
        { id: 'umbrella', name: '雨傘柄', type: 'legacy', category: 'object', description: '藏匿處', importance: 7, x: 60, y: 80, z: 0, radius: 12 },
        { id: 'truth', name: '真相', type: 'theme', category: 'object', description: '推理核心', importance: 8, x: 0, y: 110, z: 0, radius: 12 }
      ],
      links: [
        { from: 'detective', to: 'mansion', type: '調查', strength: 8, source: 'detective', target: 'mansion', width: 4 },
        { from: 'sapphire', to: 'umbrella', type: '藏於', strength: 9, source: 'sapphire', target: 'umbrella', width: 4 },
        { from: 'butler', to: 'sapphire', type: '保護', strength: 7, source: 'butler', target: 'sapphire', width: 3.5 },
        { from: 'detective', to: 'truth', type: '揭露', strength: 8, source: 'detective', target: 'truth', width: 4 }
      ],
      summary: { totalEntities: 7, totalRelationships: 4, mainThemes: ['真相','謎團','選擇'], keyInsights: '密室是人心的隱喻，動機比手法更關鍵。' }
    },

    narrativeJourney: {
      nodes: [
        { id: 'ahe', name: '阿禾', type: 'protagonist', category: 'character', description: '離鄉打工的青年', importance: 9, x: -40, y: 0, z: 0, radius: 16 },
        { id: 'train', name: '列車', type: 'setting', category: 'place', description: '返鄉之路', importance: 8, x: 40, y: 0, z: 0, radius: 14 },
        { id: 'homeDest', name: '家鄉', type: 'destination', category: 'place', description: '心之所向', importance: 8, x: 0, y: -100, z: 0, radius: 14 },
        { id: 'scarf', name: '圍巾', type: 'legacy', category: 'object', description: '送給母親的禮物', importance: 7, x: -100, y: 60, z: 0, radius: 12 },
        { id: 'river', name: '河流', type: 'obstacle', category: 'place', description: '向北的水', importance: 6, x: 100, y: 60, z: 0, radius: 10 },
        { id: 'growth', name: '成長', type: 'theme', category: 'object', description: '返鄉的領悟', importance: 8, x: 0, y: 100, z: 0, radius: 12 }
      ],
      links: [
        { from: 'ahe', to: 'train', type: '返鄉', strength: 8, source: 'ahe', target: 'train', width: 4 },
        { from: 'train', to: 'homeDest', type: '駛向', strength: 7, source: 'train', target: 'homeDest', width: 3.5 },
        { from: 'ahe', to: 'scarf', type: '攜帶', strength: 7, source: 'ahe', target: 'scarf', width: 3.5 },
        { from: 'train', to: 'river', type: '越過', strength: 6, source: 'train', target: 'river', width: 3 },
        { from: 'ahe', to: 'growth', type: '領悟', strength: 8, source: 'ahe', target: 'growth', width: 4 }
      ],
      summary: { totalEntities: 6, totalRelationships: 5, mainThemes: ['成長','家','理解'], keyInsights: '離開是繞路的回歸。' }
    },

    schoolLife: {
      nodes: [
        { id: 'team', name: '籃球隊', type: 'community', category: 'character', description: '場地使用者', importance: 7, x: -70, y: 0, z: 0, radius: 12 },
        { id: 'chorus', name: '合唱團', type: 'community', category: 'character', description: '場地使用者', importance: 7, x: 70, y: 0, z: 0, radius: 12 },
        { id: 'playground', name: '操場', type: 'setting', category: 'place', description: '彩排場地', importance: 8, x: 0, y: -100, z: 0, radius: 14 },
        { id: 'apology', name: '道歉', type: 'bond', category: 'object', description: '衝突後的修復', importance: 8, x: 0, y: 100, z: 0, radius: 12 },
        { id: 'graduation', name: '畢業', type: 'theme', category: 'object', description: '青春的轉折', importance: 8, x: 90, y: -60, z: 0, radius: 12 }
      ],
      links: [
        { from: 'team', to: 'chorus', type: '協調', strength: 7, source: 'team', target: 'chorus', width: 3.5 },
        { from: 'playground', to: 'apology', type: '見證', strength: 7, source: 'playground', target: 'apology', width: 3.5 },
        { from: 'apology', to: 'graduation', type: '成熟', strength: 7, source: 'apology', target: 'graduation', width: 3.5 }
      ],
      summary: { totalEntities: 5, totalRelationships: 3, mainThemes: ['理解','成長'], keyInsights: '青澀因互相體諒而發光。' }
    },

    historicalTale: {
      nodes: [
        { id: 'boy', name: '少年', type: 'protagonist', category: 'character', description: '負責點燈', importance: 9, x: -40, y: 0, z: 0, radius: 16 },
        { id: 'scribe', name: '女書吏', type: 'helper', category: 'character', description: '抄寫軍令', importance: 8, x: 60, y: 0, z: 0, radius: 14 },
        { id: 'wall', name: '城牆', type: 'setting', category: 'place', description: '點燈之處', importance: 8, x: 0, y: -100, z: 0, radius: 14 },
        { id: 'city', name: '小城', type: 'origin', category: 'place', description: '戰亂中的家園', importance: 7, x: -110, y: -40, z: 0, radius: 12 },
        { id: 'firelight', name: '火光', type: 'life_force', category: 'object', description: '守護的象徵', importance: 7, x: -110, y: 60, z: 0, radius: 12 },
        { id: 'duty', name: '責任', type: 'theme', category: 'object', description: '勇氣與承擔', importance: 8, x: 0, y: 100, z: 0, radius: 12 }
      ],
      links: [
        { from: 'boy', to: 'scribe', type: '相遇', strength: 7, source: 'boy', target: 'scribe', width: 3.5 },
        { from: 'wall', to: 'duty', type: '照亮', strength: 8, source: 'wall', target: 'duty', width: 4 },
        { from: 'firelight', to: 'duty', type: '象徵', strength: 7, source: 'firelight', target: 'duty', width: 3.5 }
      ],
      summary: { totalEntities: 6, totalRelationships: 3, mainThemes: ['責任','勇氣'], keyInsights: '烽煙之中仍可選擇仁義。' }
    },

    sciFiExploration: {
      nodes: [
        { id: 'crew', name: '船員', type: 'community', category: 'character', description: '探索者', importance: 8, x: -60, y: 0, z: 0, radius: 14 },
        { id: 'ship', name: '晨星號', type: 'setting', category: 'place', description: '探索船', importance: 8, x: 60, y: 0, z: 0, radius: 14 },
        { id: 'beacon', name: '訊標', type: 'legacy', category: 'object', description: '古文明遺留', importance: 9, x: 0, y: 100, z: 0, radius: 12 },
        { id: 'ice', name: '冰原', type: 'obstacle', category: 'place', description: '艱難地形', importance: 7, x: 0, y: -100, z: 0, radius: 12 },
        { id: 'homeworld', name: '故鄉行星', type: 'origin', category: 'place', description: '思念之所', importance: 7, x: -110, y: 60, z: 0, radius: 12 },
        { id: 'homeTheme', name: '家', type: 'theme', category: 'object', description: '同行者的意義', importance: 8, x: 110, y: 60, z: 0, radius: 12 }
      ],
      links: [
        { from: 'crew', to: 'ship', type: '航行', strength: 7, source: 'crew', target: 'ship', width: 3.5 },
        { from: 'ship', to: 'beacon', type: '發現', strength: 8, source: 'ship', target: 'beacon', width: 4 },
        { from: 'ship', to: 'ice', type: '穿越', strength: 7, source: 'ship', target: 'ice', width: 3.5 },
        { from: 'crew', to: 'homeTheme', type: '理解', strength: 8, source: 'crew', target: 'homeTheme', width: 4 }
      ],
      summary: { totalEntities: 6, totalRelationships: 4, mainThemes: ['探索','家'], keyInsights: '家的定義在同行者。' }
    },

    fantasyLegend: {
      nodes: [
        { id: 'boy2', name: '少年', type: 'protagonist', category: 'character', description: '銅鈴繼承者', importance: 9, x: -40, y: 0, z: 0, radius: 16 },
        { id: 'bridge', name: '雲骨橋', type: 'setting', category: 'place', description: '初霜之夜出現', importance: 8, x: 30, y: -80, z: 0, radius: 14 },
        { id: 'bell', name: '銅鈴', type: 'essence', category: 'object', description: '召喚守護獸', importance: 8, x: 30, y: 80, z: 0, radius: 12 },
        { id: 'guardian', name: '守護獸', type: 'life_force', category: 'object', description: '雪松之巔的回應', importance: 8, x: 110, y: 40, z: 0, radius: 12 },
        { id: 'vow', name: '誓約', type: 'bond', category: 'object', description: '守護與被守護', importance: 8, x: -110, y: 40, z: 0, radius: 12 }
      ],
      links: [
        { from: 'boy2', to: 'bridge', type: '踏上', strength: 7, source: 'boy2', target: 'bridge', width: 3.5 },
        { from: 'bell', to: 'guardian', type: '召喚', strength: 8, source: 'bell', target: 'guardian', width: 4 },
        { from: 'boy2', to: 'vow', type: '締結', strength: 7, source: 'boy2', target: 'vow', width: 3.5 }
      ],
      summary: { totalEntities: 5, totalRelationships: 3, mainThemes: ['尋找','守護'], keyInsights: '鈴聲引路，心意通往。' }
    },

    familyDrama: {
      nodes: [
        { id: 'father', name: '父親', type: 'helper', category: 'character', description: '病後康復', importance: 8, x: -40, y: 0, z: 0, radius: 14 },
        { id: 'siblings', name: '姊弟', type: 'community', category: 'character', description: '相互照應', importance: 8, x: 40, y: 0, z: 0, radius: 14 },
        { id: 'home', name: '家', type: 'theme', category: 'object', description: '彼此相望的方向', importance: 9, x: 0, y: 100, z: 0, radius: 12 },
        { id: 'hospital', name: '醫院', type: 'obstacle', category: 'place', description: '治療與不安之地', importance: 7, x: 0, y: -100, z: 0, radius: 12 },
        { id: 'house', name: '住家', type: 'dwelling', category: 'place', description: '回歸之所', importance: 8, x: -110, y: 60, z: 0, radius: 12 }
      ],
      links: [
        { from: 'siblings', to: 'father', type: '照顧', strength: 8, source: 'siblings', target: 'father', width: 4 },
        { from: 'house', to: 'home', type: '凝聚', strength: 8, source: 'house', target: 'home', width: 4 },
        { from: 'hospital', to: 'home', type: '對照', strength: 7, source: 'hospital', target: 'home', width: 3.5 }
      ],
      summary: { totalEntities: 5, totalRelationships: 3, mainThemes: ['親情','責任'], keyInsights: '家是一種彼此望向的方向。' }
    }
  }
};

export default knowledgeGraphMockData; 